import MathUtil from "shared/util/MathUtil";

export default class Size {

    static get zero() {
        return new Size();
    }

    /**
     * Creates an instance of Size.
     */
    constructor(readonly width: number = 0, readonly height: number = 0) {}

    get aspectRatio() {
        return this.width / this.height;
    }

    shrinkToAspectRatio(aspectRatio: number) {
        const thisRatio = this.aspectRatio;

        let w = this.width;
        let h = this.height;

        if (aspectRatio > thisRatio) {
            w = this.width;
            h = MathUtil.round(this.width / aspectRatio, 2);
        } else if (aspectRatio < thisRatio) {
            h = this.height;
            w = MathUtil.round(this.height * aspectRatio, 2);
        }

        return new Size(w, h);
    }

    /**
     * Equals.
     */
    equals(size: Size) {
        if (!size) {
            return false;
        }

        if (size === this) {
            return true;
        }

        if (size instanceof Size) {
            return this.width === size.width && this.height === size.height;
        }

        return false;
    }

    clone() {
        return new Size(this.width, this.height);
    }
}



// WEBPACK FOOTER //
// ./src/shared/xp/geom/Size.ts